import { deletePolicyType } from "../../../../../actions/Utilities/ConfigureAgreement";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeletePolicyType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (ids: number[] | undefined) => deletePolicyType(ids),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetPolicyType"]);
        toast.fire(
          "Success",
          "Policy Type were deactivated successfully",
          "success"
        );
      },
      onError: () => {
        toast.fire(
          "Bulk deactivation of Policy Type failed",
          "Server Error: Cannot deactivate Policy Type",
          "error"
        );
      },
    }
  );

  return mutate;
};
export default useDeletePolicyType;
